<template>
    <div>
        <h6>
           Trade/Credit References:
           <template v-if="editMode">
                <i v-if="tradeReferences.length < requiredTradeRefs" class="fa fa-asterisk text-danger small"></i>
                <button type="button" class="btn btn-xs btn-info" v-on:click="newTradeReference()" title="Add Trade/Credit Reference"><i class="fa fa-plus-circle"></i></button><br>
                <small v-if="showHelp && requiredTradeRefs > 0">Please provide at least {{ requiredTradeRefs }} trade/credit references</small>
                <small v-if="requiredTradeRefs === 0">(Optional)</small>
            </template>
        </h6>

        <reference-modal ref="subReferenceModal" :subcontractorId="subcontractorId" />

        <b-table bordered striped hover small responsive :items="tradeReferences" :fields="tradeReferencesFields" show-empty>
            <template v-slot:cell(sub_reference_id)="data">
                <button type="button" class="btn btn-sm btn-link" v-on:click="editReference(data.item)" title="Edit Reference"><i class="fa fa-edit"></i></button>
                <button type="button" class="btn btn-sm btn-link text-danger" v-on:click="deleteReference(data.item)" title="Delete Reference"><i class="fa fa-trash"></i></button>
            </template>
            <template #empty="scope">
                No Trade References
            </template>
        </b-table>

        <h6 style="margin-top: 50px;">
            Project References:
            <template v-if="editMode">
                <i v-if="projectReferences.length < requiredProjectRefs" class="fa fa-asterisk text-danger small"></i>
                <button type="button" class="btn btn-xs btn-info" v-on:click="newProjectReference()" title="Add Project Reference"><i class="fa fa-plus-circle"></i></button><br>

                <div class="small mt-2 mb-1" v-if="showHelp && requiredProjectRefs > 0">
                    Please provide details, contact information and reference letters for at least {{ requiredProjectRefs }} recently completed projects.  Failure to provide dated and signed reference letters will delay the review process.  If you don’t have reference letters on hand, please select “No reference letter.” In the details for each reference and {{ $store.state.user.account_name }} will contact them directly
                </div>
                <small v-if="requiredProjectRefs === 0">(Optional)</small>
            </template>
        </h6>

        <b-table bordered striped hover small responsive :items="projectReferences" :fields="projectReferenceFields" show-empty>
            <template v-slot:cell(sub_reference_id)="data">
                <button type="button" class="btn btn-sm btn-link" v-on:click="editReference(data.item)" title="Edit Bid"><i class="fa fa-edit"></i></button>
                <button type="button" class="btn btn-sm btn-link text-danger" v-on:click="deleteReference(data.item)" title="Delete Reference"><i class="fa fa-trash"></i></button>
            </template>
            <template v-slot:cell(letter)="data">
                <div v-if="data.unformatted" class="mb-2">
                    <div>{{ data.unformatted.file_name }}</div>
                    <span v-if="!data.unformatted.download_only && !printMode">
                        <a :href="`/files/view/${data.unformatted.file_id}`" target="_blank">View</a>&nbsp;|
                    </span>
                    <span v-if="!printMode">
                        <a :href="`/files/download/${data.unformatted.file_id}`" target="_blank">Download</a>
                    </span>
                    <span v-if="!printMode && editMode">
                        |&nbsp;<a href="javascript:void(0)" @click="deleteFile(data.item.sub_reference_id)" class="text-danger">Delete</a>
                    </span>
                </div>
                <span v-else-if="data.item.no_letter === 1">
                    -- No Reference Letter --
                </span>
            </template>

            <template v-slot:cell(total_amount)="data">
                {{ data.item.total_amount | currency }}
            </template>

            <template #empty="scope">
                No Project References
            </template>
        </b-table>
    </div>
</template>

<script>
    export default {
        props: {

            editMode: {
                type: Boolean,
                default: false,
            },

            subcontractorId: {
                type: Number,
                required: true,
            },

            printMode: {
                type: Boolean,
                required: false,
                default: false,
            },

            showHelp: {
                type: Boolean,
                default: true,
            },

            sectionSettings: {
                type: Object,
            },
        },

        data: function() {
            return {
                references: this.$store.state.subcontractor.references,
            }
        },

        computed: {

            requiredTradeRefs(){
                //Check settings
                if(this.sectionSettings && typeof this.sectionSettings.num_trade_credit_refs != 'undefined' && this.sectionSettings.num_trade_credit_refs !== null && this.sectionSettings.num_trade_credit_refs !== '')
                {
                    //Send it
                    return parseInt(this.sectionSettings.num_trade_credit_refs);
                }

                //Default
                return 3;
            },

            tradeReferences(){
                var refs = [];

                for (var i = this.references.length - 1; i >= 0; i--)
                {
                    //Check the type
                    if(this.references[i].ref_type == 'Trade/Credit')
                    {
                        refs.push(this.references[i]);
                    }
                }

                return refs;
            },

            requiredProjectRefs(){
                //Check settings
                if(this.sectionSettings && typeof this.sectionSettings.num_project_refs != 'undefined' && this.sectionSettings.num_project_refs !== null && this.sectionSettings.num_project_refs !== '')
                {
                    //Send it
                    return parseInt(this.sectionSettings.num_project_refs);
                }

                //Default
                return 3;
            },

            projectReferences(){
                var refs = [];

                for (var i = this.references.length - 1; i >= 0; i--)
                {
                    //Check the type
                    if(this.references[i].ref_type == 'Project')
                    {
                        refs.push(this.references[i]);
                    }
                }

                return refs;
            },

            tradeReferencesFields(){
                //Check for edit mode
                if(this.editMode)
                {
                    return [
                        {key: 'sub_reference_id', label: 'Actions'},
                        {key: 'company_name', label: 'Company'},
                        {key: 'contact_name', label: 'Contact'},
                        {key: 'phone', label: 'Phone'},
                        {key: 'email', label: 'Email'},
                        {key: 'address', label: 'Address'},
                    ];
                }

                return [
                    {key: 'company_name', label: 'Company'},
                    {key: 'contact_name', label: 'Contact'},
                    {key: 'phone', label: 'Phone'},
                    {key: 'email', label: 'Email'},
                    {key: 'address', label: 'Address'},
                ];
            },

            projectReferenceFields(){
                //Check for edit mode
                if(this.editMode)
                {
                    return [
                        {key: 'sub_reference_id', label: 'Actions'},
                        {key: 'company_name', label: 'Company'},
                        {key: 'project_name', label: 'Project'},
                        {key: 'total_amount', label: '$ Amount of Work'},
                        {key: 'type_of_work_performed', label: 'Type of Work'},
                        {key: 'project_year_complete', label: 'Completed'},
                        {key: 'contact_name', label: 'Contact'},
                        {key: 'phone', label: 'Phone'},
                        {key: 'email', label: 'Email'},
                        {key: 'address', label: 'Address'},
                        {key: 'letter', label: 'Letter'}
                    ];
                }

                return [
                    {key: 'company_name', label: 'Company'},
                    {key: 'project_name', label: 'Project'},
                    {key: 'total_amount', label: '$ Amount of Work'},
                    {key: 'type_of_work_performed', label: 'Type of Work'},
                    {key: 'project_year_complete', label: 'Completed'},
                    {key: 'contact_name', label: 'Contact'},
                    {key: 'phone', label: 'Phone'},
                    {key: 'email', label: 'Email'},
                    {key: 'address', label: 'Address'},
                    {key: 'letter', label: 'Letter'}
                ];
            }
        },

        methods: {
            deleteFile(id) {
                this.$http.post(`subcontractors/child-files-delete/reference/${id}`)
                .then(response => {
                    this.$toastr.success('Letter Removed');
                    for (let i = 0; i < this.references.length; i++)
                    {
                        if (this.references[i].sub_reference_id == id)
                        {
                            this.references[i].letter = null;
                            this.references[i].letter_file_id = null;
                            this.$store.commit('setReferences', this.references);
                        }
                    }
                })
            },

            newTradeReference(){
                //Set the prop
                this.$refs.subReferenceModal.setModel({ref_type: 'Trade/Credit'});

                //Activate the modal
                this.$refs.subReferenceModal.showModal();
            },

            newProjectReference(){
                //Set the prop
                this.$refs.subReferenceModal.setModel({ref_type: 'Project'});

                //Activate the modal
                this.$refs.subReferenceModal.showModal();
            },

            editReference(ref){
                //Set the prop
                this.$refs.subReferenceModal.setModel(ref);

                //Activate the modal
                this.$refs.subReferenceModal.showModal();
            },

            deleteReference(ref){
                //Check for confirm
                if(!confirm('Are you sure you want to delete this reference? '))
                {
                    return;
                }

                //Send it
                this.$http
                    .post('/subcontractors/reference/delete/' + ref.sub_reference_id)
                    .then(response => {
                        //Alert
                        this.$toastr.success('Reference Deleted');

                        //Delete the bid
                        this.$store.commit('deleteReference', ref);

                    });
            },
        },

        mounted() {

        }
    }
</script>